import { IErrorResponse } from "@api";
import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { ID } from "@types";
import {
  IGetServiceProviderOptions,
  getServiceProviderMetrics,
} from "../services/serviceProviders";

interface IUseContextOptions extends IGetServiceProviderOptions {
  onError?: (error: IErrorResponse) => void;
}

export const useServiceProviderMetrics = (
  serviceProviderId: ID | undefined,
  options?: IUseContextOptions
) => {
  const { data, isLoading, isError, isSuccess, status, refetch, error } =
    useDataQuery(
      ["superTalent", Number(serviceProviderId), options],
      async () => {
        const response = await getServiceProviderMetrics(
          serviceProviderId,
          options
        );
        return response.data;
      },
      {
        enabled: !!serviceProviderId,
        staleTime: 60 * 5000,
      }
    );

  return { data, isLoading, isError, isSuccess, status, error, refetch };
};
